import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Instagram, Facebook } from "lucide-react";

export default function SideMenu({ settings, base = "" }) {
  const [show, setShow] = useState(false);
  const nav = settings?.nav || [];
  const socials = settings?.socials || {};
  const href = (slug) => (slug === "home" ? `${base}/` : `${base}/${slug}`);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const socialsRow = (
    <div className="flex flex-col items-center gap-4">
      {socials.instagram ? (
        <a href={socials.instagram} target="_blank" rel="noopener noreferrer" data-testid="side-menu-instagram" aria-label="Instagram" className="text-ink2/70 hover:text-gold transition-colors">
          <Instagram size={18} />
        </a>
      ) : (
        <span className="text-ink2/40" data-testid="side-menu-instagram" aria-label="Instagram (link not set)"><Instagram size={18} /></span>
      )}
      {socials.facebook ? (
        <a href={socials.facebook} target="_blank" rel="noopener noreferrer" data-testid="side-menu-facebook" aria-label="Facebook" className="text-ink2/70 hover:text-gold transition-colors">
          <Facebook size={18} />
        </a>
      ) : (
        <span className="text-ink2/40" data-testid="side-menu-facebook" aria-label="Facebook (link not set)"><Facebook size={18} /></span>
      )}
    </div>
  );

  return (
    <AnimatePresence>
      {show && (
        <motion.nav
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          exit={{ x: "-100%" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="hidden lg:flex fixed left-0 inset-y-0 z-50 w-24 flex-col items-center justify-between border-r border-ink/10 bg-paper/95 backdrop-blur-md py-8 shadow-2xl"
          data-testid="side-menu"
        >
          <Link to={`${base}/`} data-testid="side-menu-logo" aria-label="Home">
            <img src="/logo.png" alt="Chef Blaine Guillot" className="h-16 w-auto" />
          </Link>
          <div className="flex flex-col items-center gap-7">
            {nav.filter((item) => item.slug !== "home").map((item, i) => (
              <Link
                key={i}
                to={href(item.slug)}
                data-testid={`side-menu-link-${item.slug}`}
                className="text-[10px] font-semibold uppercase tracking-[0.3em] text-ink2/70 transition-colors hover:text-gold [writing-mode:vertical-rl] rotate-180"
              >
                {item.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col items-center gap-5">
            {socialsRow}
            <span className="h-px w-8 bg-brass/50" />
            <Link to={`${base}/contact`} data-testid="side-menu-book-button" className="rounded-full bg-brass px-4 py-2 text-[10px] font-bold uppercase tracking-widest text-cast transition-colors hover:bg-flame hover:text-cream">
              Book
            </Link>
          </div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
}
